import { Component, OnInit, HostListener, ViewChild, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from '../app.settings';
import { AppService } from '../app.service';
import { Category } from '../app.models';
import { SidenavMenuService } from '../theme/components/sidenav-menu/sidenav-menu.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { AngularDeviceInformationService } from 'angular-device-information';
import { MatSidenav } from '@angular/material/sidenav';
import { SidebarService } from '../sidebar.service';
import { ThemeService } from '../theme.service';
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [SidenavMenuService]
})
export class PagesComponent implements OnInit {
  isSidebarOpen: boolean = false;
  public showBackToTop: boolean = false;
  public categories: Category[];
  public category: Category;
  public sidenavMenuItems: Array<any>;
  @ViewChild('sidenav') sidenav: any;
  public settings: Settings;
  storeid: number;
  password: any
  public pageTitle: any;
  value: any;
  id: any;
  visibleloader: boolean = false;
  user_name: any;
  stores: any;
  public showPassword: boolean = false;
  ipAddress = '';
  user_os = '';
  browser = '';
  constructor(public appSettings: AppSettings, public appService: AppService, public dialog: MatDialog, public sidenavMenuService: SidenavMenuService, public http: HttpClient,
    public router: Router, public snackBar: MatSnackBar, protected localStorage: LocalStorage, private angularFireMessaging: AngularFireMessaging, private deviceInformationService: AngularDeviceInformationService, private breakpointObserver: BreakpointObserver, private sidebarService: SidebarService,private themeService: ThemeService) {
  
    this.settings = this.appSettings.settings;
    this.appService.pagetitle.subscribe(data => {
      this.value = data.data['breadcrumb'];
    });
    if (this.pageTitle) {
      this.pageTitle = this.value;
    }
    else {
      this.pageTitle = 'Dash Board';
    }
    this.getIPAddress();
    // //console.log(deviceInformationService.isMobile());  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    // //console.log(deviceInformationService.isTablet());  // returns if the device is a tablet (tablet iPad etc)
    // //console.log(deviceInformationService.isDesktop()); // returns if the app is running on a Desktop browser.
    // //console.log(deviceInformationService.getDeviceType()); // returns if the app is running on a Desktop browser. 
    this.user_os = deviceInformationService.getDeviceInfo().os; // returns os name like Windows/Andtoid/iOS/Linux/Mac OS X etc
    // //console.log(deviceInformationService.getDeviceInfo().osVersion);  // returns os version like 10/8.1/7 ...etc
    this.browser = deviceInformationService.getDeviceInfo().browser; // returns browser name like chrome/firefox ...etc
    // //console.log(deviceInformationService.getDeviceInfo().browserVersion);  // returns browser version as number
    // //console.log(deviceInformationService.getDeviceInfo().browserMajorVersion);  // returns full browser version as number
    // //console.log(deviceInformationService.getDeviceInfo().screen_resolution);  // returns screnn size like 1390x860/640x800 ...etc
    // //console.log(deviceInformationService.getDeviceInfo().cookies);  // returns cookies enabled or no 
    // //console.log(deviceInformationService.getDeviceInfo().userAgent);  // returns userAgent
  }

  ngOnInit() {
    this.sidenavMenuItems = this.sidenavMenuService.getSidenavMenuItems();
    this.sidebarService.isSidebarOpen$.subscribe((isOpen) => {
      this.isSidebarOpen = isOpen;
    });
  }

  toggleBackground(event: any) {
    const isChecked = event.target.checked;
    this.themeService.toggleDarkMode(isChecked);
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar(!this.isSidebarOpen);
  }


  getIPAddress() {


    this.http.get("//api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;

    });
  }
  registerVendor() {
    this.appService.islogin = true;
    this.appService.Data.vendor_register = true;
    this.appService.isSellerloginbtn = true;
  }

  public changeCategory(event) {
    if (event.target) {
      this.category = this.categories.filter(category => category.name == event.target.innerText)[0];
    }
    if (window.innerWidth < 960) {
      this.stopClickPropagate(event);
    }
  }
  hideSearch() {
    this.scrollToTop
  }
  public remove(product) {
    const index: number = this.appService.Data.cartList.indexOf(product);
    if (index !== -1) {
      this.appService.Data.cartList.splice(index, 1);
      this.appService.Data.totalPrice = this.appService.Data.totalPrice - product.newPrice;
    }
  }
  public clear() {
    this.appService.Data.cartList.length = 0;
  }
  public changeTheme(theme) {
    this.settings.theme = theme;
  }
  public stopClickPropagate(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }
  onPasswordToggle() {
    this.showPassword = !this.showPassword;
  }
  public scrollToTop() {
    var scrollDuration = 200;
    var scrollStep = -window.pageYOffset / (scrollDuration / 20);
    var scrollInterval = setInterval(() => {
      if (window.pageYOffset != 0) {
        window.scrollBy(0, scrollStep);
      }
      else {
        clearInterval(scrollInterval);
      }
    }, 10);
    if (window.innerWidth <= 768) {
      setTimeout(() => { window.scrollTo(0, 0) });
    }
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    ($event.target.documentElement.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;
  }
  ngAfterViewInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && window.innerWidth < 992) {
        this.sidebarService.toggleSidebar(false);
      }
    });
    this.sidenavMenuService.expandActiveSubMenu(this.sidenavMenuService.getSidenavMenuItems());
  }
  public closeSubMenus() {
    if (window.innerWidth < 992) {
      this.sidenavMenuService.closeAllSubMenus();
    }
  }
  getLogin() {
    const login = {
      "user_name": this.user_name,
      "user_pwd": this.password,
      "app_type_id": 4,
    }

    this.appService.userlogin(login).subscribe(data => {
  
      if (data == 0) {
        this.snackBar.open('Incorrect User Name/Password  !', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      }
      else if (data == 1) {
        this.snackBar.open('Invalid User Name/Password !', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      }
      else if (data == 2) {
        this.snackBar.open('You are blocked, Please contact Admin!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      }
      else if (data == 3) {
        this.snackBar.open('Something wrong!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      }
      else if (data == 4) {
        this.snackBar.open('You are not verified!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      }
      else if (data == 5) {
        this.snackBar.open('You have no privilage!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      }
      else if (data == 6) {
        this.snackBar.open('Could not create Token!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      }
      else if (data == 7) {
        this.snackBar.open('Invalid Credentials!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      } else if (data == 8) {
        this.snackBar.open('Not Exist!', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      }
      else {
        this.angularFireMessaging.requestToken.subscribe(
          {
            next: token => {
              // Upload the user FCM token to your server.
          
              const user_data = {
                "device_fcm_token": token,
                "customer_id": data.company_users_id,
                "role_id": data.user_role_id,
                "app_type_id": 4,
                "user_ip": this.ipAddress,
                "os": this.user_os,
                "browser": this.browser,
                "location": 0,
                "unique_device_id": this.ipAddress,
              }

              this.appService.deviceRegistration(user_data).subscribe(data => { })
            },
            error: err => {
             
            }
          }
        );


        this.appService.headers = new HttpHeaders().set('Authorization', 'Bearer  ' + data.token);
        this.localStorage.setItem('user_details', data).subscribe(() => { });
        this.appService.Data.role_id = data.user_role_id;
        this.appService.Data.user_id = data.company_users_id;
        this.appService.Data.user_details = data;
        this.appService.islogin = true;
        this.appService.isSellerloginbtn = false;
        //  ============== login sucess page redirect to dashboard  =======================
        //                         code by neethu 09-01-2020     

          // this.router.navigate(["/"]);

      
      }
    },
      err => {
  
        this.snackBar.open(err.error, '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ForgotPasswordComponentDialog, {
      width: '470px',
      height: '260px',

    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
@Component({
  selector: 'forgotpassword.component-dialog',
  templateUrl: 'forgotpassword.component-dialog.html',
  styleUrls: ['./pages.component.scss'],
})
export class ForgotPasswordComponentDialog implements OnInit {
  seller_email: any;
  sendloader: boolean = false;
  constructor(public dialogRef: MatDialogRef<ForgotPasswordComponentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, public snackBar: MatSnackBar, public http: HttpClient, public appService: AppService) {

  }

  SendMail() {
    if (this.seller_email != undefined) {
      this.sendloader = true;
      const email = {
        "email": this.seller_email
      }

      this.http.post(this.appService.ecomUrl + '/sellerforgot_pwd', email, { headers: this.appService.headers }).subscribe(
        (data: any) => {


          if (data == 0) {
            this.sendloader = false;
            this.snackBar.open('User not Exist !', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
            this.dialogRef.close();
          }
          else {
            this.sendloader = false;
            this.snackBar.open('E-mail has been sent Successfully!', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
            this.dialogRef.close();
          }

        },
        err => {
  
          this.sendloader = false;
          this.snackBar.open('Enter a valid E-mail! ', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
          // this.dialogRef.close();
        }

      );
    }
    else {
      this.snackBar.open('Enter a valid E-mail! ', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      // this.dialogRef.close();
    }

  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {

  }
}